export function stopImpersonating() {
    let oldToken = localStorage.getItem('old');
    localStorage.clear();
    localStorage.setItem('token', oldToken || '');
}
